module.exports = __webpack_public_path__ + "media/images/icon_interview-2a18bcc5f9f1bbe11ce91810e64f389b.svg";